import * as React from 'react'
import { IControlProps } from './types'
import { formatDate } from '../../utils/dates'
import { GRID_CELLPADDING, GRID_CELLFONTSIZE } from './grids/consts'
import { parseISO, isValid } from 'date-fns'
import { CONFIG } from '../../config'
import DateTimePicker from '../common/DateTimePicker'

export interface IAntdDateTimeControlState {
  value: Date | null
}

export default class AntdDateTimeControl extends React.Component<
  IControlProps,
  IAntdDateTimeControlState
> {
  dateTimeFormat: string
  includeOffset: boolean
  constructor(props: IControlProps) {
    super(props)

    this.includeOffset = !!props.dateTimeIncludeOffset

    this.handleChange = this.handleChange.bind(this)
    if (props.dateTimeFormat) {
      // eslint-disable-next-line no-useless-escape
      this.dateTimeFormat = props.dateTimeFormat.replace(/\'/gi, '')
    } else {
      this.dateTimeFormat = CONFIG.displayDateTimeFormat
    }
    this.dateTimeFormat = this.dateTimeFormat
      .replace(/:ss/g, '')
      .replace(/:s/g, '')

    const initialValue = this.fromStoredValue(props.field.value || '')
    this.state = {
      value: initialValue
    }
  }

  fromStoredValue(value: string): Date | null {
    const parsed = parseISO(value)
    return isValid(parsed) ? parsed : null
  }

  toStoredValue(value: Date | null): string {
    if (!value) return ''
    return this.includeOffset
      ? formatDate('utc', value) // e.g., "2025-06-25T10:00:00Z"
      : formatDate('iso', value) // e.g., "2025-06-25T10:00:00"
  }

  handleChange(date: Date | null): void {
    const validDate = date && isValid(date) ? date : null
    this.props.form.setFieldValue(
      this.props.field.name,
      this.toStoredValue(validDate)
    )
    this.setState({ value: validDate })
  }

  render() {
    if (this.props.gridCell) {
      const value = this.fromStoredValue(this.props.field.value || '')
      const displayValue = value
        ? formatDate('display_datetime', value, this.dateTimeFormat)
        : ''
      return (
        <div
          id={this.props.id}
          style={{ padding: GRID_CELLPADDING, fontSize: GRID_CELLFONTSIZE }}
        >
          {displayValue}
        </div>
      )
    } else {
      return (
        <DateTimePicker
          id={this.props.id}
          value={this.state.value as Date}
          onChange={this.handleChange}
          displayFormat={this.dateTimeFormat}
          style={{
            borderRadius: '4px',
            boxSizing: 'border-box',
            marginTop: '20px'
          }}
          size='large'
          showTime={true}
          use12Hours={true}
          disabled={this.props.disabled}
          inputReadOnly={true}
        />
      )
    }
  }
}
